import { useState } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyDatePicker from '../../components/forms/datePicker'

const EditJobFairTime = (props) => {
  const [formValue, setFormValue] = useState({
    start_time: props.data.job_fair_start_time,
    end_time: props.data.job_fair_end_time
  })

  const handleOk = () => {
    axios.post('/admin/event/config/update', { 
      job_fair_start_time: formValue.start_time,
      job_fair_end_time: formValue.end_time
    })
      .then(function (response) {
        if (response.errcode === 0) {
          props.isCancel()
          props.getEventConfig()
          message.success('修改成功！')
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title='双选会起止时间'
      width='500px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okText="保存">

      <MyDatePicker
        id="start_time"
        label='开始时间'
        placeholder='选择时间'
        value={formValue.start_time}
        onChange={setFormValue}
        styles={{width: '440px'}}
        format = 'YYYY-MM-DD HH:mm:ss'
        showTime
      />

      <MyDatePicker
        id="end_time"
        label='结束时间'
        placeholder='选择时间'
        value={formValue.end_time}
        onChange={setFormValue}
        styles={{width: '440px'}}
        format = 'YYYY-MM-DD HH:mm:ss'
        showTime
      />

    </Modal>
  )
}

export default EditJobFairTime
